import React, { createContext, useContext, useEffect, useState } from "react";
import {
  List,
  Button,
  Typography,
  Tooltip,
  message,
  notification,
  Badge,
  Popconfirm,
  Skeleton,
  Select,
  Form,
} from "antd";

import "../../settings/style/commercialobligationsettings.css";
import { Dialog, DialogFooter } from "@fluentui/react/lib/Dialog";
import { TextField } from "@fluentui/react/lib/TextField";
import {
  PrimaryButton,
  DefaultButton,
} from "@fluentui/react/lib/Button";
import * as yup from "yup";
import { observer } from "mobx-react";
import { Formik } from "formik";
import { Scrollbars } from "react-custom-scrollbars";
import FormItem from "antd/lib/form/FormItem";
import { Spinner, SpinnerSize } from "@fluentui/react";

import { MessageBar, MessageBarType } from "@fluentui/react";
import CommercialStore from "../store/CommercialStore";
import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { getCurrentUser } from "../../../Utility/modules/helpers";
import { HelpCircle } from "react-feather";
const { Title } = Typography;

const { Option } = Select;
const commercialStoreCtx = createContext(CommercialStore);
export const CommercialObligationSettings = observer((props) => {
  const commercialStore = useContext(commercialStoreCtx);
  const permissionStore = {};
  const [state, setState] = useState({
    hideDialog: true,
    action: "",
    selRow: {},
  });

  useEffect(() => {
    async function loadContracts() {
      try {
        await commercialStore.loadContracts();
      } catch (error) {
        notification.error({
          message: "Feedback Manager",

          description: `Something went wrong.${error.message}.`,
        });
      }
    }
    loadContracts();
  }, []);

  const _closeDialog = () => {
    setState({ hideDialog: true });
  };
  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const contract = { ...values, uploadedBy: getCurrentUser().fullName };
      const retVal = await commercialStore.createContract(contract);
      commercialStore.contractCenters.set(retVal.contractId, retVal);

      message.success(`${contract.name} created successfully`);

      setState({ hideDialog: true });
    } catch (error) {
      console.log(error);
      notification.open({
        message: "Feedback Manager",
        type: "error",

        description: `Something went wrong.${error.message}.`,
      });
      setSubmitting(false);
    }
  };
  return (
    <div
      className="ms-Grid"
      dir="ltr"
      style={{ borderRight: "1px solid #F0F2F5", marginRight: "5px" }}
    >
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          {" "}
          <Scrollbars style={{ height: "100vh", overflowX: "hidden" }}>
            {commercialStore.isLoading ? (
              <>
                <Skeleton active />
                <Skeleton active />
                <Skeleton active />
              </>
            ) : (
              <List
                itemLayout="horizontal"
                dataSource={[...commercialStore.contractCenters.values()]}
                size="small"
                style={{ width: "95%" }}
                header={
                  <div className="ms-Grid" dir="ltr">
                    <div className="ms-Grid-row">
                      <div className="ms-Grid-col ms-sm10">
                        {" "}
                        <Title
                          level={4}
                          style={{
                            display: "inline-block",
                            marginRight: "5px",
                            fontSize: "16px",
                            color: "red",
                          }}
                        >
                          Contract Centres
                        </Title>
                        <Badge count={commercialStore.contractCenters.size} />
                      </div>
                      <div
                        className="ms-Grid-col ms-sm2"
                        style={{
                          textAlign: "right",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <Tooltip title="Add Contract Centre">
                          <Button
                            shape="circle"
                            icon={<PlusOutlined />}
                            type="primary"
                            onClick={(ev) => {
                              setState({
                                hideDialog: false,
                                action: "add",
                                header: `Create New  Contract Centre`,
                                selRow: {},
                              });
                            }}
                          />
                        </Tooltip>
                      </div>
                    </div>
                    <div className="ms-Grid-row" style={{ paddingTop: "10px" }}>
                      <div className="ms-Grid-col ms-sm12">
                        <MessageBar messageBarType={MessageBarType.warning}>
                          click an contract center for users and permissions
                        </MessageBar>
                      </div>
                    </div>
                  </div>
                }
                renderItem={(item) => (
                  <List.Item
                    actions={[
                      <Tooltip
                        title={`modify ${item?.contractCenter} contract center`}
                      >
                        <Button
                          type="link"
                          icon={<EditOutlined />}
                          disabled
                          style={{ fontSize: "18px" }}
                          onClick={() => {
                            setState({
                              action: `edit`,
                              header: `Change ${item?.contractCenter.toLowerCase()} contract center attribute`,
                              hideDialog: false,
                              selRow: item,
                            });
                          }}
                        />
                      </Tooltip>,
                      <Tooltip
                        title={`Delete ${item?.contractCenter.toLowerCase()} contract center`}
                      >
                        <Popconfirm
                          title={`Are you sure you want to remove ${item?.contractCenter} contract center？`}
                          okText="Yes"
                          cancelText="No"
                          onConfirm={() => {
                            try {
                              permissionStore.removePriviledge(item);
                              message.success(
                                `${item.name} contract center removal was successfull`
                              );
                            } catch (error) {
                              message.error(
                                `something went wrong  due to : ${error.message} `
                              );
                            }
                          }}
                        >
                          <Button
                            type="link"
                            disabled
                            icon={<DeleteOutlined />}
                            style={{ fontSize: "18px" }}
                          />
                        </Popconfirm>
                      </Tooltip>,
                      <Tooltip
                        title={
                          <div className="ms-Grid" dir="ltr">
                            {" "}
                            <div className="ms-Grid-row">
                              <div className="ms-Grid-col ms-sm12">audit</div>
                            </div>
                            <div className="ms-Grid-row">
                              <div className="ms-Grid-col ms-4">created by</div>{" "}
                              <div className="ms-Grid-col ms-8">
                                {item?.uploadedBy}
                              </div>
                            </div>
                            <div className="ms-Grid-row">
                              <div className="ms-Grid-col ms-sm12">
                                {item?.uploadedOn}
                              </div>
                            </div>
                          </div>
                        }
                      >
                        <Button type="link" icon={<HelpCircle />} size={16} />
                      </Tooltip>,
                    ]}
                  >
                    <List.Item.Meta
                      title={<span>{item.contractCenter}</span>}
                      description={item.description}
                    />
                  </List.Item>
                )}
              />
            )}
          </Scrollbars>
        </div>
      </div>
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          <Dialog
            hidden={state.hideDialog}
            onDismiss={_closeDialog}
            dialogContentProps={{
              title: state.header,
              subText: "Enter name and description for the contract center.",
            }}
            modalProps={{
              isBlocking: false,
              styles: { main: { maxWidth: 450 } },
              dragOptions: true,
            }}
          >
            <Formik
              initialValues={state.selRow}
              onSubmit={(values, { setSubmitting }) => {
                handleSubmit(values, { setSubmitting });
              }}
              validationSchema={yup.object().shape({
                contractCenter: yup
                  .string()
                  .required(" contract center is required"),
                unit: yup
                  .string()
                  .required("contract center unit  is required"),
              })}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue,
              }) => {
                return (
                  <Form onFinish={handleSubmit} layout="vertical">
                    <div className="ms-Grid" dir="ltr">
                      <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12">
                          <TextField
                            label="Contract Center "
                            required
                            name="contractCenter"
                            value={values?.contractCenter}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            errorMessage={
                              touched.contractCenter && errors.contractCenter
                            }
                          />
                        </div>
                      </div>{" "}
                      <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm6">
                          <TextField
                            label="Unit"
                            required
                            name="unit"
                            value={values?.unit}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            errorMessage={touched.unit && errors.unit}
                          />
                        </div>
                      </div>
                      <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12">
                          <FormItem label="Description">
                            <TextField
                              multiline
                              rows={5}
                              name="description"
                              value={values?.description}
                              onBlur={handleBlur}
                              onChange={handleChange}
                            />
                          </FormItem>
                        </div>
                      </div>
                      <div
                        className="ms-Grid-row"
                        style={{ marginTop: "10px" }}
                      >
                        <div className="ms-Grid-col ms-sm12">
                          {isSubmitting && (
                            <Spinner
                              label="saving, please wait..."
                              ariaLive="assertive"
                              labelPosition="right"
                              size={SpinnerSize.large}
                            />
                          )}
                        </div>
                      </div>
                      <DialogFooter>
                        <PrimaryButton text="Save" type="submit" />
                        <DefaultButton onClick={_closeDialog} text="Cancel" />
                      </DialogFooter>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </Dialog>
        </div>
      </div>
    </div>
  );
});

